import { createSelector } from 'reselect'

const getSteamHasLoggedIn = state => state.steamReducer.hasLoggedIn
const getSteamAttemptingLogin = state => state.steamReducer.attemptingLogin
export const isSteamStartup = state => state.steamReducer.steamStartup
const getSteamTicket = state => state.steamReducer.ticket
const getUsedSteamTicket = state => state.steamReducer.usedTicket

export const getSteamInfo = createSelector(
    [
        getSteamHasLoggedIn,
        getSteamAttemptingLogin,
        isSteamStartup,
        getSteamTicket,
        getUsedSteamTicket,
    ],
    (hasLoggedIn, attemptingLogin, steamStartup, ticket, usedTicket) => ({
        hasLoggedIn,
        attemptingLogin,
        steamStartup,
        ticket,
        usedTicket,
    }),
)



// WEBPACK FOOTER //
// ./src/features/Steam/data/selectors.js